import Vue from 'vue'
import sinisterTransformer from '@/transformers/catalog/warehouse/returnedAmounts'

/**
 * @author jorge nuñez lópez <>
 *
 * Fetch returned supplies amount list
 * @return {List}
 */

export default (warehouseId) => {
  return Vue.$http.get(`/iwarehouse/list-re_entry/${warehouseId}/`)
    .then(({ data }) => {
      const dataTransformed = sinisterTransformer.fetchCollection(data.sinisters)
      return dataTransformed
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchReturnedAmounts.js